/* Formless theme JS */
(function () {
  'use strict';
  var F = window.Formless || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartDrawer: true };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var overlay = $('[data-overlay]');
  var openPanel = null;

  function formatMoney(cents) {
    var fmt = F.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withCommas;
    });
  }

  /* ---------- Panels (drawers, mobile nav) ---------- */
  function open(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) close(openPanel);
    openPanel = panel;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    document.body.classList.add('is-locked');
    var focusEl = panel.querySelector('button, a, input');
    if (focusEl) setTimeout(function () { focusEl.focus(); }, 50);
  }
  function close(panel) {
    panel = panel || openPanel;
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('is-visible'); setTimeout(function () { if (!openPanel) overlay.hidden = true; }, 300); }
    document.body.classList.remove('is-locked');
    openPanel = null;
  }
  if (overlay) overlay.addEventListener('click', function () { close(); closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closeSearch(); } });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-mobile-nav]')) { open($('[data-mobile-nav]')); }
    else if (t.closest('[data-close-mobile-nav]') || t.closest('[data-close-cart]') || t.closest('[data-close-filters]')) { close(); }
    else if (t.closest('[data-open-filters]')) { open($('[data-filter-drawer]')); }
    else if (t.closest('[data-open-cart]') && F.cartDrawer && $('[data-cart-drawer]')) { e.preventDefault(); open($('[data-cart-drawer]')); }
    else if (t.closest('[data-open-search]')) { toggleSearch(); }
    else if (t.closest('[data-close-search]')) { closeSearch(); }
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0, interval = parseInt(bar.dataset.interval, 10) || 4000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Header height var (for sticky toolbars) ---------- */
  function setHeaderH() {
    var h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  setHeaderH(); window.addEventListener('resize', setHeaderH);

  /* ---------- Search + predictive ---------- */
  var searchPanel = $('[data-search-panel]');
  function toggleSearch() {
    if (!searchPanel) return;
    if (searchPanel.hidden) { searchPanel.hidden = false; var i = $('[data-predictive-input]', searchPanel); if (i) i.focus(); }
    else closeSearch();
  }
  function closeSearch() { if (searchPanel) searchPanel.hidden = true; }
  var pInput = $('[data-predictive-input]');
  var pResults = $('[data-predictive-results]');
  var pTimer;
  if (pInput && pResults) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      pTimer = setTimeout(function () {
        fetch(F.routes.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { pResults.innerHTML = '<p class="plp__count">No results for “' + escapeHtml(q) + '”</p>'; return; }
            pResults.innerHTML = '<div class="predictive">' + products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
              return '<a class="predictive__item" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
                '<span>' + escapeHtml(p.title) + '</span><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            }).join('') + '<a class="predictive__all" href="' + F.routes.root.replace(/\/$/, '') + '/search?type=product&q=' + encodeURIComponent(q) + '">See all results</a></div>';
          }).catch(function () {});
      }, 250);
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Cart ---------- */
  function sectionsUrl() { return F.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer'; }
  function renderCart(sections) {
    var html = sections && sections['cart-drawer'];
    var drawer = $('[data-cart-drawer]');
    if (html && drawer) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
      }
    }
  }
  function updateCount() {
    return fetch(F.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      return cart;
    });
  }
  function refreshCart() {
    return fetch(sectionsUrl()).then(function (r) { return r.json(); }).then(function (s) { renderCart(s); return updateCount(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-line-key]');
    if (!line) return;
    e.preventDefault();
    line.classList.add('is-loading');
    fetch(F.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.dataset.lineKey, quantity: parseInt(btn.dataset.qtyChange, 10), sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.sections) renderCart(res.sections); else return refreshCart();
      return updateCount();
    }).catch(function () { line.classList.remove('is-loading'); });
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('form.product-form');
    var idInput = form && form.querySelector('[data-variant-id]');
    var addBtn = form && form.querySelector('[data-add-button]');
    var addLabel = form && form.querySelector('[data-add-label]');
    var errorEl = form && form.querySelector('[data-form-error]');
    var picker = section.querySelector('[data-variant-picker]');
    var variantsEl = picker && picker.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var priceWrap = section.querySelector('[data-product-price]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var mediaList = section.querySelector('[data-media-list]');

    function selectedOptions() {
      return $$('fieldset[data-option-index]', picker).map(function (fs) {
        var c = fs.querySelector('input:checked, select');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      $$('fieldset[data-option-index]', picker).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10);
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      $$('fieldset[data-option-index]', picker).forEach(function (fs, i) {
        var v = fs.querySelector('[data-option-value]'); if (v) v.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var variant = findVariant(opts);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (priceWrap) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (sale ? '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price) + '</s>' : '') + '</div>';
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);    var stickyVar = section.querySelector('[data-sticky-variant]'); if (stickyVar) stickyVar.textContent = variant.options.join(' / ');
      var url = section.dataset.productUrl + '?variant=' + variant.id;
      window.history.replaceState({}, '', url);
      showVariantMedia(variant);
    }
    // Put the selected variant's media first (main image on desktop, first slide on mobile);
    // the remaining media keep their original product order.
    function showVariantMedia(variant) {
      if (!variant || !variant.featured_media || !mediaList) return;
      var target = mediaList.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (!target) return;
      var items = $$('.pdp__media', mediaList);
      items.forEach(function (el) { el.classList.toggle('is-selected', el === target); });
      if (target !== mediaList.firstElementChild) {
        var idx = function (el) { var n = parseInt(el.dataset.mediaIndex, 10); return isNaN(n) ? 0 : n; };
        var rest = items.filter(function (el) { return el !== target; }).sort(function (a, b) { return idx(a) - idx(b); });
        [target].concat(rest).forEach(function (el) { mediaList.appendChild(el); });
        var img = target.querySelector('img');
        if (img) img.loading = 'eager';
        mediaList.scrollTo({ left: 0, behavior: 'auto' });
        $$('.pdp__dot', section).forEach(function (d, n) { d.classList.toggle('is-active', n === 0); });
      }
    }
    if (picker) {
      picker.addEventListener('change', updateVariant);
      markAvailability(selectedOptions());
      // Initial load (and browser-restored selections): make sure the gallery matches the selected variant.
      if (new URLSearchParams(window.location.search).has('variant')) { showVariantMedia(findVariant(selectedOptions())); }
    }

    // Quantity steppers
    $$('[data-qty-step]', section).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('.qty__input');
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
        input.value = v;
      });
    });

    // Gallery dots (mobile)
    var dots = $$('.pdp__dot', section);
    if (mediaList && dots.length) {
      mediaList.addEventListener('scroll', function () {
        var i = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    // AJAX add to cart
    if (form && F.cartDrawer && $('[data-cart-drawer]')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (addBtn) addBtn.classList.add('is-loading');
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch(F.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.description) {
              if (errorEl) { errorEl.textContent = res.description; errorEl.hidden = false; }
              return;
            }
            if (res.sections) renderCart(res.sections); else return refreshCart().then(function () { open($('[data-cart-drawer]')); });
            return updateCount().then(function () { open($('[data-cart-drawer]')); });
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      });
    }

    // Sticky mobile add-to-cart
    var sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', e.intersectionRatio < 1);
      }, { threshold: 1 }).observe(addBtn);
    }

    // Share
    var share = section.querySelector('[data-share]');
    if (share) share.addEventListener('click', function () {
      if (navigator.share) navigator.share({ title: share.dataset.title, url: share.dataset.url }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(share.dataset.url).then(function () { share.textContent = 'Link copied'; });
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.querySelector('.card')) return;
    var load = function () {
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Collection: sort + filters ---------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });
  var filterForm = $('[data-filter-form]');
  if (filterForm) filterForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var params = new URLSearchParams();
    new FormData(filterForm).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    window.location.search = params.toString();
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function () { setHeaderH(); });
})();
